import { render } from "./FooterAd.vue?vue&type=template&id=2d0fbb3e&scoped=true"
import script from "./FooterAd.vue?vue&type=script&lang=js"
export * from "./FooterAd.vue?vue&type=script&lang=js"

import "./FooterAd.vue?vue&type=style&index=0&id=2d0fbb3e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0fbb3e"]])

export default __exports__